module.exports = __webpack_public_path__ + "static/img/message-box.d95b313f.svg";